<template>
	<div>
		<empty :icon="iconEmpty" :title="titleEmpty" :description="descriptionEmpty">
	        <slot v-if="showSlot"></slot>
	    </empty>
	</div>
</template>
<script>
	export default {
		props: {
			icon: String,
			title: String,
			description: String,
		},

		data(){
			return {
				search: '',
				showSlot: false,
			}
		},

		mounted(){
			this.search = this.findGetParameter('search');
			if(this.search != null){
				this.search = decodeURIComponent(this.search);
			}
		},

		methods: {
			findGetParameter: function(parameterName) {
		    	var result = null,
		        tmp = [];
		    	location.search
		        	.substr(1)
		        	.split("&")
		        	.forEach(function (item) {
		        tmp = item.split("=");
		        	if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
		        	
		        	});
		    	return result;
			}
		},

		computed: {
            iconEmpty: function () {
            	if(this.search){
            		return 'sentiment_dissatisfied';
            	}

                return this.icon ? this.icon : 'event_busy';
            },

            titleEmpty: function () {
            	if(this.search){
            		return 'No se han encontrado resultados.';
            	}

                return this.title ? this.title : 'No hay registros';
            },

            descriptionEmpty: function () {
            	if(this.search){
            		return 'Lo sentimos, no hay resultados para <b>'+ this.search+'</b>';
            	}
            	
                return this.description;
            },
        },

        watch: {
        	search: function(val){
        		this.showSlot = val ? false : true;
        	}
        }
	}
</script>